<template>
  <nav class="nav-bar" :class="{'nav-bar--sm': smallNav, 'nav-bar-bg-img': hasNavBGImg}">
    <div class="nav-container">
      <div class="logo-wrap" :class="[colorTheme ? `logo-wrap--${colorTheme}` : '']">
        <a :href="homeLink">
          <slot name="logo">
            <img :src="isMobile ? mobileLogo : logo" :alt="`${brandName} logo`">
          </slot>
        </a>
        <div class="nav-bar__divider" />
        <slot name="tagline" />
      </div>
      <slot />
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',

  props: {
    homeLink: {
      type: String,
      default: '/'
    },
    brandLogo: {
      type: String,
      default: 'bionic-logo-light.svg'
    },
    brandMobileLogo: {
      type: String,
      default: 'bionic-logo-light.svg'
    },
    brandName: {
      type: String,
      default: 'Bionic'
    },
    smallNav: {
      type: Boolean,
      default: false
    },
    colorTheme: {
      type: String,
      default: ''
    },
    hasNavBGImg: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logo: require(`../assets/logos/${this.brandLogo}`),
      mobileLogo: require(`../assets/logos/${this.brandMobileLogo}`)
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  }
}
</script>
<style lang="scss" scoped>
.nav-bar {
  height: 93px;
  position: relative;
  color: $white;
  padding-bottom: $spacing-16;
  background: $nav-bar-bg;
  background-image: linear-gradient(to right, $nav-bar-bg-secondary, $nav-bar-bg);
  z-index: $nav-bar-z-index;

  @media (max-width: $screen-md) {
    height: 52px;
    padding-bottom: $spacing-8;
  }

  &--sm {
  height: 77px;

  @media (max-width: $screen-sm) {
    height: 50px ;
    padding-bottom: $spacing-8;
  }

  .dividing-line {
    height: 60px;
    background-color: $nav-border-color;
  }

  .phone-number {
      @media (min-width: $screen-md) {
          padding-top: 8px;
       }
  }

    .nav-container  {
      border: 1px solid $nav-border-color;
    }

    div.logo-wrap {
      font-family: $font-family;
      font-size: 12px;
      font-weight: normal;

      @media (min-width: $screen-md) {
        font-size: 18px;
      }

      &--purple {
        color: $purple-4;
      }

    }
  }

  &-bg-img {
      background-image: url($nav-bar-bg-img) !important;
      background-size: cover !important;

    .nav-container {
      border: unset;
      border-top: 1px solid white;
    }
  }

  .nav-container {
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;
    padding: $spacing-0 $spacing-24;

    @media (max-width: $screen-md) {
      padding: $spacing-0 $spacing-16;
    }
  }

  .logo-wrap {
    img {
      height: 42px;

      @media (max-width: $screen-md) {
        height: $nav-bar-mobile-image-size;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: $font-family-bold;
    font-size: 20px;

    @media (max-width: $screen-md) {
      font-size: $nav-bar-mobile-font-size;
    }
  }

  &.dark {
    background-color: $home-header-bg;
    padding-top: $spacing-64;

    .logo-wrap {
      img {
        height: 36px;
      }
    }

    @media (max-width: $screen-md) {
      padding-top: $spacing-20;

      .logo-wrap {
        img {
          height: 20px;
        }
      }
    }
  }
}
</style>
